export default __webpack_public_path__ + "media/zurb/img/ecommerce/loyalty_4-e3f7d28b6700c15f0b12bfba43346bc3.png";